<script setup>

import { inject, ref, watch, nextTick } from 'vue';
import { 
	apiModifierTextesBriquesRapport,
	apiSelectionnerValeur } from '@/services/ServiceModele.js';
	import {
	getPositionBriqueRapport } from '@/scripts/global.js';
import Dropdown from 'primevue/dropdown';

const { selecteur, modeEdition } = defineProps({
	selecteur: Object,
	modeEdition: Boolean
});

const emit = defineEmits(['activationModeEdition', 'desactivationModeEdition']);

const appelerApiModifModele = inject('appelerApiModifModele');

const libelleSaisi = ref(selecteur.libelle);
const valeurSelectionnee = ref(getValeurSelectionnee(selecteur.indiceValSelect, selecteur.valeurs));
const composantSaisieLibelle = ref(null);

watch(() => selecteur.valeurs, (valeurs) => {
	valeurSelectionnee.value = getValeurSelectionnee(selecteur.indiceValSelect, valeurs);
})

watch(() => selecteur.indiceValSelect, (indice) => {
	valeurSelectionnee.value = getValeurSelectionnee(indice, selecteur.valeurs);
})

watch(() => modeEdition, (edition) => {
	if (edition) {
		nextTick(() => {
			composantSaisieLibelle.value.select();
		});
	} else {
		libelleSaisi.value = selecteur.libelle;
	}
});

function getValeurSelectionnee(indice, valeurs) {
	if (indice == -1) {
		return null;
	} else {
		return valeurs[indice];
	}
}

function modifierLibelle() {
	const infosBriqueRapport = {
				positionBrique: getPositionBriqueRapport(selecteur),
				texte: libelleSaisi.value
			};
	appelerApiModifModele(apiModifierTextesBriquesRapport, [infosBriqueRapport], (reponseOK) => {
		if (reponseOK) {
			emit('desactivationModeEdition');
		}
	});
}

function selectionnerValeur(indiceValeur) {
	appelerApiModifModele(apiSelectionnerValeur, selecteur, indiceValeur);
}

function changerValeur(valeur) {
	if (valeur) {
		selectionnerValeur(selecteur.valeurs.findIndex(val => val == valeurSelectionnee.value));
	}
}

</script>

<template>
	<div class="selecteur" 
	  :style="selecteur.style">
		<label v-if="!modeEdition" 
			class="intitule"
			@dblclick="emit('activationModeEdition')">{{ selecteur.libelle }} :</label>
		<input v-else 
			type="text"
			ref="composantSaisieLibelle"
			v-model="libelleSaisi"
			placeholder="Libellé"
			@keydown.enter.exact.prevent="modifierLibelle()"
			@keydown.escape.prevent.stop="$emit('desactivationModeEdition')" 
			@blur="$emit('desactivationModeEdition')" />
		<Dropdown 
			v-model="valeurSelectionnee" 
			:options="selecteur.valeurs" 
			:selectOnFocus="true"
			@change="changerValeur($event.value)"/>
	</div>
</template>

<style scoped>

.selecteur {
	display: flex;
	border-style: solid;
	border-width: 0px;
}

select {
	min-width: 80px;
}

label {
	margin-right: 10px;
}

</style>